export default __webpack_public_path__ + "static/6-6e1af1d37658986d2b01301e868e6fd8.png";